// Import FirebaseAuth and firebase.
import { GoogleAuthProvider } from 'firebase/auth';
import StyledFirebaseAuth from './StyledFirebaseAuth';
import { auth } from './firebase';

// // Configure Firebase.
// const config = {
//   apiKey: 'AIzaSyAeue-AsYu76MMQlTOM-KlbYBlusW9c1FM',
//   authDomain: 'myproject-1234.firebaseapp.com',
//   // ...
// };
// firebase.initializeApp(config);

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '/listings',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  ],
};

const Login = () => (
  <div>
    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
  </div>
)

export default Login